import ScoreInterface from "../Interfaces/ScoreInterface";

import axios from 'axios';

export default class Score implements ScoreInterface
{
    el: HTMLElement;
    timerEl: HTMLElement;
    scoreEl: HTMLElement;
    highScoreEl: HTMLElement;

    time: number = 0;
    score: number = 0;
    multiplier: number = 0;
    active: boolean = false;
    high_score: number = 0;

    constructor()
    {
        this.el = document.createElement('div');
        this.el.id = 'Score';

        this.timerEl = document.createElement('span');
        this.timerEl.innerHTML = '0';
        this.timerEl.classList.add('score');
        this.el.appendChild(document.createTextNode('Clock'));
        this.el.appendChild(this.timerEl);

        this.scoreEl = document.createElement('span');
        this.scoreEl.innerHTML = '0';
        this.scoreEl.classList.add('score');
        this.el.appendChild(document.createTextNode('Score'));
        this.el.appendChild(this.scoreEl);

        // High Score
        this.highScoreEl = document.createElement('span');
        this.highScoreEl.classList.add('score');
        axios.get('https://levi.lol/api/game/high-score')
            .then(res => {
                this.high_score = parseInt(res.data.score);
                this.highScoreEl.innerHTML = this.high_score.toString();
                this.el.appendChild(document.createTextNode('High Score'));
                this.el.appendChild(this.highScoreEl);
            })
            .catch(err => {
                console.error(err);
            });
        //

        let _this = this;
        setInterval(function() {
            if(!_this.active) {
                return;
            }
            _this.time++;
            _this.timerEl.innerHTML = _this.time.toString();

            _this.score = _this.score + (_this.multiplier * 1);
            _this.scoreEl.innerHTML = _this.score.toString();
        }, 1000);
    }

    render(): HTMLElement
    {
        return this.el;
    }

    increaseMultiplier(): void
    {
        this.multiplier++;
    }

    activate(): void
    {
        this.active = true;
    }

    deactivate(): void
    {
        this.active = false;
    }
}
